// extracted by mini-css-extract-plugin
export default {"address":"WalletAddress_address__XPilk","address__char":"WalletAddress_address__char__hDESO"};